/**
 * Basic area interface.
 * 
 * @todo @export
 *
 * @interface BasicArea
 */
interface BasicArea {

  /** Basic area id. */
  _id: string;

  /** Current state. */
  active: boolean;

  /** Creation date as ISO string. */
  created: string;

  /** Display name. */
  displayName: string;

  /** Basic area name. */
  name: string;

  /** Project level. */
  projectLevel: number;

  /** Quality level. */
  qualityLevel: string;

  /** Requirements. */
  requirements: any[];

  /** Selected. */
  selected: boolean;

  /** Selected proxy. */
  selectedProxy: boolean;

  /** Basic area's template id. Also accepts complete area template entity */
  templateId: AreaTemplate | AreaTemplate['_id'];

  /** Last updated date as ISO string. */
  updated: string;
};
